import { GwMap } from "./map"
class ProjectsMap extends GwMap {
  constructor(element) {
    super(element, true)
  }
}

export default function init() {
  if (document.querySelector(".ProjectsLandingPage")) {
    const mapElement = document.getElementById("map")

    if (mapElement) {
      new ProjectsMap(mapElement)
    }
  }
}
